import styled from '@emotion/styled';

import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import MainSectionFactory from './MainSectionFactory';
import {
  MainSection,
  MainSectionType,
} from '../../interfaces/MainSection.interface';
import { loadMainSection } from '../../slice';
import { isPC } from '../../../../util/window/getDevice';

const pcDefaultHeight = 500;

const pcTemplateHeights: Record<MainSectionType, number> = {
  'MAIN_BANNERS': 371,
  'TODAY_RECOMMEND_PRODUCTS': 584.75,
  'SPECIAL_DEALS': 607.5,
  'LINE_BANNERS': 140,
  'RECIPES': 422.98,
  'MD_CHOICES': 727.56,
  'RANDOM_COLLECTION': 584.75,
  'CLOSING_SALE': 561.56,
  'INSTAGRAM_REVIEW': 455.56,
  'BAND_BANNER': pcDefaultHeight,
  'CATEGORY_RANKING': pcDefaultHeight,
  'KURLY_ONLY': pcDefaultHeight,
  'KURLY_TREND_RANKING': pcDefaultHeight,
  'LIST_PRODUCT': pcDefaultHeight,
  'REVIEW_PRODUCTS': pcDefaultHeight,
  'TIME_RANKING': pcDefaultHeight,
};

const Container = styled.div<{ type: MainSectionType; isPc: boolean; isLoading: boolean; }>`
  height: ${({ type, isPc, isLoading }) =>
    isLoading ? isPc ? `${pcTemplateHeights[type]}px}` : '500px' : '100%'};
`;

interface Props {
  section: MainSection<unknown>;
}

export default function MainSectionInViewDispatcher({ section }: Props) {
  const { id, type, hasLoaded, isLoading } = section;
  const { ref, inView } = useInView({
    rootMargin: '1000px',
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!inView || hasLoaded) {
      return;
    }

    dispatch(loadMainSection(id, type));
  }, [dispatch, hasLoaded, id, inView, type]);

  return (
    <Container ref={ref} type={type} isPc={isPC} isLoading={isLoading}>
      <MainSectionFactory section={section}/>
    </Container>
  );
}
